import { render, staticRenderFns } from "./HolidaysModal.vue?vue&type=template&id=b02a0148&scoped=true&"
import script from "./HolidaysModal.vue?vue&type=script&lang=js&"
export * from "./HolidaysModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b02a0148",
  null
  
)

export default component.exports